import { Logger } from 'common/logger';
import { turbine1hQuery, lightningQuery, catchErrorsV2 } from '../ReportsAPI';
import { getSelectedItems } from 'common/state.helper';
import { NO_DATA_VALUE } from 'lib/components/_charts/Chart.utils';

const defaultState = {
    totalGenerationData: [],
    windSpeedData: [],
    observedLightningData: [],
};

export const turbineGenerationChart = {
    name: 'turbineGenerationChart',
    state: defaultState,

    reducers: {
        setChartData(state, { totalGenerationData, windSpeedData, observedLightningData }) {
            return {
                ...state,
                totalGenerationData,
                windSpeedData,
                observedLightningData,
            };
        },

        resetChartData() {
            return defaultState;
        },
    },

    effects: (dispatch) => ({
        async loadAll() {
            await catchErrorsV2(
                () => dispatch.turbineGenerationChart.queryData(),
                () => dispatch.turbineGenerationChart.resetChartData()
            );
        },

        async queryData(_, rootState) {
            const { selectedDate, selectedParkId, selectedTurbineKey } = getSelectedItems(rootState);

            try {
                const { data } = await turbine1hQuery(selectedDate, selectedParkId, selectedTurbineKey);
                const { data: lightning } = await lightningQuery(selectedDate, selectedParkId);

                const totalGenerationData = [];
                const windSpeedData = [];
                const observedLightningData = [];

                data.forEach((item) => {
                    const { wind_speed, total_generation, ts } = item;

                    totalGenerationData.push({
                        value: total_generation || NO_DATA_VALUE,
                        key: ts,
                    });
                    windSpeedData.push({
                        value: wind_speed || NO_DATA_VALUE,
                        key: ts,
                    });
                });

                lightning.forEach((item) => {
                    const { ts } = item;

                    observedLightningData.push({
                        key: ts,
                    });
                });

                dispatch.turbineGenerationChart.setChartData({
                    totalGenerationData,
                    windSpeedData,
                    observedLightningData,
                });
            } catch (error) {
                Logger.error('Error querying data: ', error);
                throw error; // Rethrow to handle in loadAll
            }
        },
    }),
};

export default turbineGenerationChart;
